import Vue from 'vue';
import Vuex from 'vuex';

import { subscribePendingStoreActions } from './plugins';

// MODULES /////////////////////////////////////////////////////////////////////
import mockWidgetInstanceStore from './mockWidgetInstanceStore';
import app from './modules/App';
import access from './modules/Access';
import agents from './modules/Agents';
import users from './modules/Users';
import domains from './modules/Domains';
import numbers from './modules/Numbers';
import ivrMenu from './modules/IvrMenu';
import widgets from './modules/Widgets';
import settings from './modules/Settings';
import blacklist from './modules/Blacklist';
import connections from './modules/Connections';
import departments from './modules/Departments';
import permissions from './modules/Permissions';
import userProfiles from './modules/UserProfiles';
import notifications from './modules/Notifications';
import promotionCodes from './modules/PromotionCodes';
import callRecordings from './modules/CallRecordings';
import callbackMessages from './modules/CallbackMessages';
import permissionsCategories from './modules/PermissionsCategories';
import contactFormSendMail from './modules/ContactFormSendMail';
import contactFormSettings from './modules/ContactFormSettings';
import contactFormCategories from './modules/ContactFormCategories';
import configurationFormSendMail from './modules/ConfigurationFormSendMail';

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    app,
    access,
    widgets,
    departments,
    agents,
    users,
    domains,
    numbers,
    ivrMenu,
    settings,
    blacklist,
    connections,
    permissions,
    userProfiles,
    notifications,
    promotionCodes,
    callRecordings,
    callbackMessages,
    permissionsCategories,
    mockWidgetInstanceStore,
    contactFormSendMail,
    contactFormSettings,
    contactFormCategories,
    configurationFormSendMail,
  },
  plugins: [subscribePendingStoreActions],
  strict: !process.env.DEBUG_MODE,
});

export default store;
